
import { useState } from 'react';
import { toast } from 'sonner';
import { AUTO_PUBLISH_INTERVALS } from '@/components/feeder/AutoPublishControls';

export function usePublishInterval() {
  const [publishInterval, setPublishInterval] = useState(5); // Changed from 30 to 5 seconds
  const [selectedPreset, setSelectedPreset] = useState<string>('Nå (5 sekunder)');
  const [customInterval, setCustomInterval] = useState('');
  const [showCustomInterval, setShowCustomInterval] = useState(false);
  
  // Handle interval selection
  const handleIntervalChange = (value: string) => {
    if (value === 'custom') {
      setShowCustomInterval(true);
    } else {
      setShowCustomInterval(false);
      setSelectedPreset(value);
      setPublishInterval(AUTO_PUBLISH_INTERVALS[value as keyof typeof AUTO_PUBLISH_INTERVALS]);
    }
  };

  // Handle custom interval input
  const handleCustomIntervalChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCustomInterval(e.target.value);
  };

  // Apply custom interval
  const applyCustomInterval = () => {
    const seconds = parseInt(customInterval);
    if (!isNaN(seconds) && seconds > 0) {
      setPublishInterval(seconds);
      toast.success(`Egendefinert intervall satt til ${seconds} sekunder`);
    } else {
      toast.error('Vennligst skriv inn et positivt tall for sekunder');
    }
  };

  return {
    publishInterval,
    selectedPreset,
    customInterval,
    showCustomInterval,
    handleIntervalChange,
    handleCustomIntervalChange,
    applyCustomInterval
  };
}
